const getNextOccurrence = (dateString) => {
  if (!dateString) return null;

  const sourceDate = new Date(dateString);

  if (isNaN(sourceDate)) return null;

  const today = new Date();

  const currentDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );

  const nextDate = new Date(
    currentDate.getFullYear(),
    sourceDate.getMonth(),
    sourceDate.getDate()
  );

  if (nextDate < currentDate) {
    nextDate.setFullYear(currentDate.getFullYear() + 1);
  }

  return nextDate;
};

export const getUpcomingBirthdays = (employees) => {
  return employees
    .map((employee) => ({
      ...employee,
      nextBirthday: getNextOccurrence(employee.dob),
    }))
    .filter((employee) => employee.nextBirthday)
    .sort(
      (a, b) =>
        a.nextBirthday.getTime() -
        b.nextBirthday.getTime()
    )
    .slice(0, 3);
};

export const getUpcomingAnniversaries = (employees) => {
  return employees
    .map((employee) => ({
      ...employee,
      nextAnniversary: getNextOccurrence(
        employee.joiningDate
      ),
    }))
    .filter((employee) => employee.nextAnniversary)
    .sort(
      (a, b) =>
        a.nextAnniversary.getTime() -
        b.nextAnniversary.getTime()
    )
    .slice(0, 3);
};

export const getNextHoliday = (holidays) => {
  const today = new Date();

  const currentDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );

  return holidays
    .filter(
      (holiday) =>
        new Date(holiday.date) >= currentDate
    )
    .sort(
      (a, b) =>
        new Date(a.date) - new Date(b.date)
    )[0];
};